var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "700" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
      _vm.printProgress !== undefined
        ? _c("w-progress-linear", {
            staticClass: "progress",
            attrs: { value: _vm.printProgress },
          })
        : _vm._e(),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-card-content" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-select-sale-layout", {
                    attrs: {
                      id: "",
                      disabled: _vm.buttonsDisabled,
                      "add-default-option": "",
                      fancy: "",
                      "sale-type-id": _vm.sale.TypeID,
                      label: _vm.$ct("layout"),
                      multi: "",
                    },
                    model: {
                      value: _vm.layoutIds,
                      callback: function ($$v) {
                        _vm.layoutIds = $$v
                      },
                      expression: "layoutIds",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: {
                      fancy: "",
                      label: _vm.$ct("as-duplicate"),
                      disabled: _vm.buttonsDisabled,
                    },
                    model: {
                      value: _vm.isDuplicate,
                      callback: function ($$v) {
                        _vm.isDuplicate = $$v
                      },
                      expression: "isDuplicate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._l(_vm.radioButtons, function (item) {
            return _c(
              "w-row",
              { key: item.value },
              [
                _c(
                  "w-col",
                  { attrs: { xs: "12" } },
                  [
                    _c("w-radio", {
                      attrs: {
                        disabled: _vm.buttonsDisabled,
                        name: _vm.radioName,
                        "element-value": item.value,
                        label: item.text,
                        checked: _vm.printContext == item.value,
                      },
                      on: {
                        input: function ($event) {
                          _vm.printContext = item.value
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c("w-row"),
              ],
              1
            )
          }),
        ],
        2
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { disabled: _vm.buttonsDisabled, icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: _vm.buttonsDisabled, icon: "print" },
              on: {
                click: function ($event) {
                  return _vm.print()
                },
              },
            },
            [_vm._v(_vm._s(_vm.confirmText))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }